import React, { createContext, ReactNode } from 'react';
import { RoleDto } from '../hooks/useRole';

interface RoleContextType {
  roles: RoleDto[] | null;
  setRoles: React.Dispatch<React.SetStateAction<RoleDto[] | null>>;
}

// eslint-disable-next-line react-refresh/only-export-components
export const RoleContext = createContext<RoleContextType | undefined>(
  undefined
);

export const RoleProvider: React.FC<{ children: ReactNode }> = ({
  children,
}) => {
  const [roles, setRoles] = React.useState<RoleDto[] | null>(null);
  return (
    <RoleContext.Provider value={{ roles, setRoles }}>
      {children}
    </RoleContext.Provider>
  );
};
